import { z } from 'zod';

import { CompositionSchema, LevelSchema, SquadStatusSchema, WeekdaySchema } from '../enums';
import { HHmmSchema, IdSchema } from './common';
import { ActivityRefSchema, GatheringPublicSchema } from './gathering';
import { MemberPublicSchema } from './member';

/** Публичный DTO отряда для `squad.my` (BLUEPRINT 6): состав, капитан, ближайший сбор, группа. */
export const SquadPublicSchema = z.object({
  id: IdSchema,
  name: z.string().nullable(),
  emblem: z.string().nullable(),
  composition: CompositionSchema,
  status: SquadStatusSchema,
  primaryActivity: ActivityRefSchema,
  cityName: z.string(),
  timezone: z.string(),
  weekday: WeekdaySchema,
  startTime: HHmmSchema,
  levelBand: LevelSchema,
  ageMin: z.number().int(),
  ageMax: z.number().int(),
  districtNames: z.array(z.string()),
  capacity: z.number().int().positive(),
  minToLaunch: z.number().int().positive(),
  reserveCapacity: z.number().int().nonnegative(),
  captain: MemberPublicSchema.nullable(),
  members: z.array(MemberPublicSchema),
  /** Роль текущего пользователя в отряде */
  me: z.object({ isCaptain: z.boolean(), isReserve: z.boolean() }),
  tgInviteLink: z.string().url().nullable(),
  /** Группа привязана (`tgChatId`), даже если ссылки нет — бот не админ (раунд 4, C1) */
  hasGroup: z.boolean(),
  saleDeadline: z.string().datetime().nullable(),
  /** Текущий видимый сезон (SALE/ACTIVE/FINISHED) — подробности в `season.current` */
  seasonId: IdSchema.nullable(),
  /** Ближайший предстоящий сбор текущего сезона */
  nextGathering: GatheringPublicSchema.nullable(),
});
export type SquadPublic = z.infer<typeof SquadPublicSchema>;

/** «Пожаловаться» на участника состава: `Flag OTHER` с текстом, разбор — ops в Stage 9. */
export const SquadReportInputSchema = z.object({
  squadId: IdSchema,
  userId: IdSchema,
  text: z.string().trim().min(5, 'Опиши, что случилось').max(1000),
});
export type SquadReportInput = z.infer<typeof SquadReportInputSchema>;
